import {HttpResponse} from '@angular/common/http';
import {Response} from '@angular/http';

export class FileUtils {

    public static saveFile(filename: string, body: Blob) {
        const blobURL = window.URL.createObjectURL(body);
        const anchor = document.createElement('a');
        anchor.download = filename;
        anchor.href = blobURL;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        setTimeout(function () {
            window.URL.revokeObjectURL(blobURL);
        }, 100);
    }

    public static getFilename(response: Response | HttpResponse<any>): string {
        const contentDisposition = response.headers.get('content-disposition');
        return contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, '');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/file.utils.ts